(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sort"] && !Shopify.designMode) return;
  try {
    (() => {
    const ICONS = {
      featured:
        '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path fill="currentColor" d="M3.5 5.75A.75.75 0 0 1 4.25 5h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 3.5 5.75Zm0 4A.75.75 0 0 1 4.25 9h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3.5 9.75Zm0 4a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75Z"/></svg>',
      asc:
        '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path fill="currentColor" d="M6.5 16.5a.75.75 0 0 1-.75-.75V6.06L3.53 8.28a.75.75 0 1 1-1.06-1.06l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06L7.25 6.06v9.69a.75.75 0 0 1-.75.75Zm6.25-11.5h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5Zm0 4h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5Zm0 4h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Z"/></svg>',
      desc:
        '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path fill="currentColor" d="M6.5 3.5a.75.75 0 0 1 .75.75v9.69l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V4.25a.75.75 0 0 1 .75-.75Zm6.25 1.5h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Zm0 4h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5Zm0 4h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5Z"/></svg>',
    };

    const iconForValue = (value, defaultSort) => {
      if (value === 'price-ascending') return 'asc';
      if (value === 'price-descending') return 'desc';
      return 'featured';
    };

    const initSort = (root) => {
      const select = root.querySelector('[data-collection-sort-select]');
      const iconEl = root.querySelector('[data-collection-sort-icon]');
      if (!select) return;

      const defaultSort = select.getAttribute('data-default-sort') || 'manual';

      const syncIcon = () => {
        if (!iconEl) return;
        const key = iconForValue(select.value, defaultSort);
        iconEl.innerHTML = ICONS[key] || ICONS.featured;
      };

      select.addEventListener('change', () => {
        syncIcon();
        try {
          const url = new URL(window.location.href);
          const next = select.value || defaultSort;
          if (next === defaultSort) {
            url.searchParams.delete('sort_by');
          } else {
            url.searchParams.set('sort_by', next);
          }
          url.searchParams.delete('page');
          window.location.assign(`${url.pathname}${url.search}${url.hash}`);
        } catch (e) {
          /* ignore */
        }
      });

      syncIcon();
    };

    const boot = () => {
      document.querySelectorAll('[data-collection-sort]').forEach(initSort);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["consentmo-theme"] && !Shopify.designMode) return;
  try {
    (() => {
    const cfg = window.__PF_CONSENT_GEO__ || {};
    const GDPR = new Set(
      (cfg.gdprCountries || []).map((c) => String(c).toUpperCase()).concat(['UK'])
    );
    const US_CONSENT_STATES = new Set(
      (cfg.usConsentStates || ['CA']).map((s) => String(s).toUpperCase())
    );
    const CACHE_KEY = 'pf_consent_geo_v2';
    const AUTO_KEY = 'pf_consent_auto_accepted';
    const READY_KEY = 'pf_consent_banner_ready_v1';
    const CACHE_TTL_MS = 1000 * 60 * 60 * 24;
    const STYLE_ATTR = 'data-pf-consent-theme';
    const root = document.documentElement;

    const THEME_CSS = `
      /* Kill Consentmo's left:50% + translateX(-50%) centering so the bar stays flush */
      .csm-wrapper {
        box-sizing: border-box !important;
        position: fixed !important;
        top: auto !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        max-width: none !important;
        height: auto !important;
        margin: 0 !important;
        transform: none !important;
        translate: none !important;
        pointer-events: none !important;
      }
      .isense-cc-window.cc-banner,
      .cc-window.cc-banner {
        box-sizing: border-box !important;
        position: fixed !important;
        top: auto !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        transform: none !important;
        translate: none !important;
        padding: 0.7rem 1.5rem !important;
        border: 0 !important;
        border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
        border-radius: 0 !important;
        background: rgba(0, 0, 0, 0.82) !important;
        color: #fff !important;
        box-shadow: 0 -0.5rem 1.25rem rgba(0, 0, 0, 0.35) !important;
        backdrop-filter: blur(12px) saturate(140%) !important;
        -webkit-backdrop-filter: blur(12px) saturate(140%) !important;
        font-family: inherit !important;
        font-size: 0.8125rem !important;
        line-height: 1.45 !important;
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 1rem 1.25rem !important;
        z-index: 280 !important;
        pointer-events: auto !important;
      }
      .cookieconsent-wrapper,
      .isense-cookieconsent-wrapper,
      .csm-banner-text-wrapper {
        display: contents !important;
      }
      .isense-cc-message,
      .cc-message {
        flex: 1 1 auto !important;
        margin: 0 !important;
        max-width: none !important;
        color: rgba(255, 255, 255, 0.72) !important;
        font-size: 0.8125rem !important;
        line-height: 1.45 !important;
      }
      .isense-cc-link,
      .cc-link {
        color: #ff5a2a !important;
        font-weight: 600 !important;
        text-decoration: none !important;
        border-bottom: 1px solid rgba(255, 90, 42, 0.4) !important;
      }
      /* Specificity must beat Consentmo hashed mobile column-reverse rules */
      .isense-cc-window.cc-banner .cc-compliance.cc-highlight,
      .isense-cc-window.cc-banner .isense-cc-compliance.isense-cc-highlight,
      .cc-window.cc-banner .cc-compliance.cc-highlight {
        display: flex !important;
        flex: 0 0 auto !important;
        flex-direction: row !important;
        flex-flow: row nowrap !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        justify-content: flex-end !important;
        gap: 0.4rem !important;
        margin: 0 !important;
        width: auto !important;
        max-width: none !important;
      }
      .isense-cc-window.cc-banner .cc-btn,
      .isense-cc-window.cc-banner .isense-cc-btn,
      .isense-cc-window.cc-banner .cc-allow,
      .isense-cc-window.cc-banner .cc-deny,
      .isense-cc-window.cc-banner .cc-settings,
      .cc-window.cc-banner .cc-btn {
        display: inline-flex !important;
        flex: 0 0 auto !important;
        align-items: center !important;
        justify-content: center !important;
        align-self: auto !important;
        width: auto !important;
        max-width: none !important;
        min-height: 2rem !important;
        margin: 0 !important;
        padding: 0 1rem !important;
        border-radius: 999px !important;
        cursor: pointer !important;
        font-size: 0.6875rem !important;
        font-weight: 700 !important;
        letter-spacing: 0.08em !important;
        text-transform: uppercase !important;
        box-shadow: none !important;
        white-space: nowrap !important;
      }
      .isense-cc-window.cc-banner .cc-allow,
      .isense-cc-window.cc-banner .isense-cc-allow {
        border: 0 !important;
        background: #ff5a2a !important;
        color: #000 !important;
      }
      .isense-cc-window.cc-banner .cc-settings,
      .isense-cc-window.cc-banner .isense-cc-settings {
        border: 1px solid rgba(255, 255, 255, 0.14) !important;
        background: transparent !important;
        color: #8a8a8a !important;
      }
      .isense-cc-window.cc-banner .cc-deny,
      .isense-cc-window.cc-banner .isense-cc-deny {
        border: 1px solid rgba(255, 255, 255, 0.1) !important;
        background: transparent !important;
        color: #8a8a8a !important;
      }
      .isense-cc-settings-dialog,
      .cc-dialog {
        border: 1px solid rgba(255, 255, 255, 0.1) !important;
        border-radius: 12px !important;
        background: #0f0f0f !important;
        color: #fff !important;
        box-shadow: 0 1.5rem 3rem rgba(0, 0, 0, 0.55) !important;
      }
      .isense-cc-settings-dialog h1,
      .isense-cc-settings-dialog h2,
      .cc-dialog h1,
      .cc-dialog h2 {
        color: #fff !important;
        font-weight: 800 !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
      }
      @media (max-width: 749px) {
        .isense-cc-window.cc-banner,
        .cc-window.cc-banner {
          flex-wrap: wrap !important;
          padding: 0.65rem 0.85rem calc(0.65rem + env(safe-area-inset-bottom, 0px)) !important;
          gap: 0.55rem !important;
        }
        .isense-cc-message,
        .cc-message {
          flex: 1 1 100% !important;
          font-size: 0.75rem !important;
          line-height: 1.4 !important;
        }
        .isense-cc-window.cc-banner .cc-compliance.cc-highlight,
        .isense-cc-window.cc-banner .isense-cc-compliance.isense-cc-highlight,
        .cc-window.cc-banner .cc-compliance.cc-highlight {
          width: 100% !important;
          justify-content: flex-end !important;
        }
      }
    `;

    const setMode = (mode) => {
      root.classList.remove('pf-gdpr-pending', 'pf-gdpr-show', 'pf-gdpr-skip');
      root.classList.add(mode);
    };

    const markAutoAccepted = () => {
      try {
        localStorage.setItem(AUTO_KEY, '1');
      } catch (e) {
        /* ignore */
      }
    };

    const wasAutoAccepted = () => {
      try {
        return localStorage.getItem(AUTO_KEY) === '1';
      } catch (e) {
        return false;
      }
    };

    const clearAutoAccepted = () => {
      try {
        localStorage.removeItem(AUTO_KEY);
      } catch (e) {
        /* ignore */
      }
    };

    const styleShadowHosts = () => {
      document.querySelectorAll('csm-cookie-consent').forEach((host) => {
        // Host must not clip the fixed banner (Consentmo sets overflow:auto).
        host.style.setProperty('overflow', 'visible', 'important');
        host.style.setProperty('position', 'static', 'important');
        host.style.setProperty('height', 'auto', 'important');
        host.style.setProperty('pointer-events', 'none', 'important');

        const shadow = host.shadowRoot;
        if (!shadow) return;
        let style = shadow.querySelector(`style[${STYLE_ATTR}]`);
        if (!style) {
          style = document.createElement('style');
          style.setAttribute(STYLE_ATTR, '');
          shadow.appendChild(style);
        }
        if (style.textContent !== THEME_CSS) style.textContent = THEME_CSS;

        // Inline overrides beat Consentmo hashed selectors that force a stacked
        // "mobile" column layout on desktop widths.
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        shadow.querySelectorAll('.isense-cc-window.cc-banner, .cc-window.cc-banner').forEach((banner) => {
          banner.style.setProperty('transform', 'none', 'important');
          banner.style.setProperty('translate', 'none', 'important');
          banner.style.setProperty('left', '0', 'important');
          banner.style.setProperty('right', '0', 'important');
          banner.style.setProperty('bottom', '0', 'important');
          banner.style.setProperty('width', '100%', 'important');
          banner.style.setProperty('max-width', 'none', 'important');
          banner.style.setProperty('flex-direction', 'row', 'important');
          banner.style.setProperty('flex-wrap', isMobile ? 'wrap' : 'nowrap', 'important');
          banner.style.setProperty('pointer-events', 'auto', 'important');
        });
        shadow.querySelectorAll('.csm-wrapper').forEach((wrap) => {
          wrap.style.setProperty('transform', 'none', 'important');
          wrap.style.setProperty('left', '0', 'important');
          wrap.style.setProperty('right', '0', 'important');
          wrap.style.setProperty('bottom', '0', 'important');
          wrap.style.setProperty('width', '100%', 'important');
          wrap.style.setProperty('overflow', 'visible', 'important');
          wrap.style.setProperty('height', 'auto', 'important');
          wrap.style.setProperty('pointer-events', 'none', 'important');
        });
        shadow.querySelectorAll('.isense-cc-compliance, .cc-compliance').forEach((el) => {
          el.style.setProperty('flex-direction', 'row', 'important');
          el.style.setProperty('flex-flow', 'row nowrap', 'important');
          el.style.setProperty('display', 'flex', 'important');
          el.style.setProperty('width', isMobile ? '100%' : 'auto', 'important');
          el.style.setProperty('justify-content', 'flex-end', 'important');
        });
        shadow.querySelectorAll('.isense-cc-btn, .cc-btn').forEach((btn) => {
          btn.style.setProperty('width', 'auto', 'important');
          btn.style.setProperty('flex', '0 0 auto', 'important');
        });
      });
    };

    const clearConsentCookies = () => {
      const expire = 'Thu, 01 Jan 1970 00:00:00 GMT';
      ['cookieconsent_status', 'cookieconsent_preferences_disabled'].forEach((name) => {
        document.cookie = `${name}=; expires=${expire}; path=/`;
        document.cookie = `${name}=; expires=${expire}; path=/; SameSite=Lax`;
      });
    };

    const resetConsentmoForBanner = () => {
      clearConsentCookies();
      try {
        if (typeof window.Consentmo?.reset === 'function') {
          window.Consentmo.reset();
          return true;
        }
      } catch (e) {
        /* continue */
      }
      return false;
    };

    const needsConsent = (location) => {
      if (!location?.country) return false;
      const country = String(location.country).toUpperCase();
      const region = String(location.region || '').toUpperCase();
      if (GDPR.has(country) || (country === 'UK' && GDPR.has('GB'))) return true;
      if (country === 'US' && region && US_CONSENT_STATES.has(region)) return true;
      return false;
    };

    const readCache = () => {
      try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.country || !parsed?.ts) return null;
        if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
        return {
          country: String(parsed.country).toUpperCase(),
          region: parsed.region ? String(parsed.region).toUpperCase() : '',
        };
      } catch (e) {
        return null;
      }
    };

    const writeCache = (location) => {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            country: String(location.country).toUpperCase(),
            region: location.region ? String(location.region).toUpperCase() : '',
            ts: Date.now(),
          })
        );
      } catch (e) {
        /* ignore */
      }
    };

    const autoAcceptConsentmo = () => {
      markAutoAccepted();
      const accept = () => {
        try {
          if (typeof window.Consentmo?.acceptAll === 'function') {
            window.Consentmo.acceptAll();
            return true;
          }
        } catch (e) {
          /* continue */
        }
        const host = document.querySelector('csm-cookie-consent');
        const btn = host?.shadowRoot?.querySelector(
          '.isense-cc-allow, .cc-btn.cc-allow, .cc-allow'
        );
        if (btn) {
          btn.click();
          return true;
        }
        return false;
      };
      if (accept()) return;
      const observer = new MutationObserver(() => {
        if (accept()) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    };

    const applyLocation = (location, { fromCache = false } = {}) => {
      if (!location?.country) {
        setMode('pf-gdpr-show');
        styleShadowHosts();
        return;
      }

      if (!fromCache) writeCache(location);

      if (needsConsent(location)) {
        setMode('pf-gdpr-show');

        const cookieStatus = document.cookie.match(/cookieconsent_status=([^;]*)/)?.[1] || '';
        const prefsDisabled = /cookieconsent_preferences_disabled=/.test(document.cookie);
        let legacyUsSkip = false;
        try {
          const legacy = JSON.parse(localStorage.getItem('pf_gdpr_country_v1') || 'null');
          legacyUsSkip = legacy?.country === 'US' && !legacy?.region;
        } catch (e) {
          legacyUsSkip = false;
        }

        let firstReady = false;
        try {
          firstReady = !localStorage.getItem(READY_KEY);
          if (firstReady) localStorage.setItem(READY_KEY, '1');
        } catch (e) {
          firstReady = false;
        }

        // One-time recovery: prior geo-skip auto-accepted CA visitors, or first
        // load of the fixed shadow-DOM gate — clear Consentmo so the banner can show.
        if (
          firstReady ||
          wasAutoAccepted() ||
          (cookieStatus === 'accept_all' && legacyUsSkip) ||
          (prefsDisabled && wasAutoAccepted())
        ) {
          clearAutoAccepted();
          try {
            localStorage.removeItem('pf_gdpr_country_v1');
          } catch (e) {
            /* ignore */
          }
          resetConsentmoForBanner();
        }

        styleShadowHosts();
      } else {
        setMode('pf-gdpr-skip');
        autoAcceptConsentmo();
      }
    };

    const fetchLocation = async () => {
      const endpoints = [
        async () => {
          const res = await fetch('https://ipwho.is/', { credentials: 'omit' });
          if (!res.ok) throw new Error('ipwho.is failed');
          const data = await res.json();
          if (!data?.success || !data.country_code) throw new Error('ipwho.is invalid');
          return {
            country: data.country_code,
            region: data.region_code || data.region || '',
          };
        },
        async () => {
          const res = await fetch('https://ipapi.co/json/', { credentials: 'omit' });
          if (!res.ok) throw new Error('ipapi.co failed');
          const data = await res.json();
          if (!data?.country_code || data.error) throw new Error('ipapi.co invalid');
          return {
            country: data.country_code,
            region: data.region_code || data.region || '',
          };
        },
      ];

      for (const run of endpoints) {
        try {
          const location = await run();
          if (location?.country) {
            return {
              country: String(location.country).toUpperCase(),
              region: location.region ? String(location.region).toUpperCase() : '',
            };
          }
        } catch (e) {
          /* try next */
        }
      }
      return null;
    };

    const boot = async () => {
      styleShadowHosts();
      const observer = new MutationObserver(() => styleShadowHosts());
      observer.observe(document.documentElement, { childList: true, subtree: true });

      const cached = readCache();
      if (cached) {
        applyLocation(cached, { fromCache: true });
        return;
      }

      if (cfg.hintNeedsConsent) setMode('pf-gdpr-show');

      const location = await fetchLocation();
      if (location) {
        applyLocation(location);
        return;
      }

      if (cfg.hintNeedsConsent) {
        setMode('pf-gdpr-show');
      } else if (cfg.hintCountry) {
        applyLocation({ country: cfg.hintCountry, region: '' });
      } else {
        setMode('pf-gdpr-show');
      }
    };

    boot();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["digital-withdrawal-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.PFDigitalWaiver) return;

    const ATTR_KEYS = [
      'eu_digital_waiver',
      'eu_digital_waiver_version',
      'eu_digital_waiver_at',
      'eu_digital_waiver_text',
    ];
    const GEO_CACHE_KEY = 'pf_consent_geo_v2';
    const GEO_CACHE_TTL_MS = 1000 * 60 * 60 * 24;

    const roots = () => Array.from(document.querySelectorAll('[data-digital-waiver]'));
    const scopes = () => Array.from(document.querySelectorAll('[data-digital-waiver-scope]'));

    const findScope = (el) => el.closest('[data-digital-waiver-scope]') || el.parentElement;

    const parseEuCodes = (root) =>
      new Set(
        String(root?.dataset.euCodes || '')
          .split(',')
          .map((code) => code.trim().toUpperCase())
          .filter(Boolean)
      );

    const isEuCountry = (country, euCodes) => {
      if (!country) return false;
      const code = String(country).toUpperCase();
      return euCodes.has(code) || (code === 'UK' && euCodes.has('GB'));
    };

    const setRequired = (required) => {
      roots().forEach((root) => {
        root.hidden = !required;
      });
      scopes().forEach((scope) => {
        scope.dataset.waiverRequired = required ? 'true' : 'false';
      });
      if (!required) {
        scopes().forEach((scope) => {
          scope.querySelectorAll('[name="checkout"], [data-digital-waiver-checkout]').forEach((btn) => {
            btn.removeAttribute('disabled');
            btn.setAttribute('aria-disabled', 'false');
          });
        });
        return;
      }
      sync();
    };

    const setAcceptedUI = (accepted, { showHint = false, saving = false } = {}) => {
      roots().forEach((root) => {
        const unlocked = accepted && !saving;
        root.dataset.accepted = unlocked ? 'true' : 'false';
        const input = root.querySelector('[data-digital-waiver-input]');
        if (input) {
          // Keep the box checked while an accept is saving; only clear on reject.
          if (saving && accepted) input.checked = true;
          else input.checked = accepted;
          input.disabled = saving;
        }

        const hint = root.querySelector('[data-digital-waiver-hint]');
        if (hint) hint.hidden = !(showHint && !accepted && !saving);

        const savingHint = root.querySelector('[data-digital-waiver-saving]');
        if (savingHint) savingHint.hidden = !saving;

        root.querySelectorAll('[data-waiver-attr]').forEach((field) => {
          const keyName = field.dataset.waiverAttr;
          if (!accepted) {
            field.value = '';
            field.disabled = true;
            return;
          }
          field.disabled = false;
          if (keyName === 'eu_digital_waiver') field.value = 'accepted';
          if (keyName === 'eu_digital_waiver_version') field.value = root.dataset.waiverVersion || '';
          if (keyName === 'eu_digital_waiver_at') field.value = field.value || new Date().toISOString();
          if (keyName === 'eu_digital_waiver_text') field.value = root.dataset.waiverLabel || '';
        });

        const scope = findScope(root);
        if (!scope) return;
        scope.dataset.waiverAccepted = unlocked ? 'true' : 'false';

        if (root.dataset.gateCheckout === 'true' && scope.dataset.waiverRequired === 'true') {
          scope.querySelectorAll('[name="checkout"], [data-digital-waiver-checkout]').forEach((btn) => {
            const locked = !unlocked;
            btn.toggleAttribute('disabled', locked);
            btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
          });
        }
      });
    };

    const persistCartAttributes = async (accepted, root) => {
      const label = root?.dataset.waiverLabel || '';
      const version = root?.dataset.waiverVersion || '';
      const stampedAt = accepted ? new Date().toISOString() : '';
      const attributes = {
        eu_digital_waiver: accepted ? 'accepted' : '',
        eu_digital_waiver_version: accepted ? version : '',
        eu_digital_waiver_at: stampedAt,
        eu_digital_waiver_text: accepted ? label : '',
      };

      const response = await fetch(window.theme?.routes?.cartUpdateUrl || '/cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes }),
      });
      if (!response.ok) throw new Error('Unable to save consent');
      return { cart: await response.json(), stampedAt };
    };

    const sync = () => {
      const anyAccepted = roots().some((root) => {
        const input = root.querySelector('[data-digital-waiver-input]');
        return Boolean(input?.checked || root.dataset.accepted === 'true');
      });
      setAcceptedUI(anyAccepted);
    };

    const waiverIsRequired = () =>
      scopes().some((scope) => scope.dataset.waiverRequired === 'true') ||
      roots().some((root) => !root.hidden);

    const readGeoCache = () => {
      try {
        const raw = localStorage.getItem(GEO_CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.country || !parsed?.ts) return null;
        if (Date.now() - parsed.ts > GEO_CACHE_TTL_MS) return null;
        return String(parsed.country).toUpperCase();
      } catch (_) {
        return null;
      }
    };

    const writeGeoCache = (country) => {
      try {
        const existing = (() => {
          try {
            return JSON.parse(localStorage.getItem(GEO_CACHE_KEY) || 'null') || {};
          } catch (_) {
            return {};
          }
        })();
        localStorage.setItem(
          GEO_CACHE_KEY,
          JSON.stringify({
            country: String(country).toUpperCase(),
            region: existing.region || '',
            ts: Date.now(),
          })
        );
      } catch (_) {
        /* ignore */
      }
    };

    const fetchIpCountry = async () => {
      const endpoints = [
        async () => {
          const res = await fetch('https://ipwho.is/', { credentials: 'omit' });
          if (!res.ok) throw new Error('ipwho.is failed');
          const data = await res.json();
          if (!data?.success || !data.country_code) throw new Error('ipwho.is invalid');
          return String(data.country_code).toUpperCase();
        },
        async () => {
          const res = await fetch('https://ipapi.co/json/', { credentials: 'omit' });
          if (!res.ok) throw new Error('ipapi.co failed');
          const data = await res.json();
          if (!data?.country_code || data.error) throw new Error('ipapi.co invalid');
          return String(data.country_code).toUpperCase();
        },
      ];

      for (const run of endpoints) {
        try {
          const country = await run();
          if (country) return country;
        } catch (_) {
          /* try next */
        }
      }
      return null;
    };

    const resolveRequirement = async () => {
      const sample = roots()[0];
      if (!sample) return;

      const euCodes = parseEuCodes(sample);
      const marketCountry =
        sample.dataset.marketCountry ||
        window.Shopify?.country ||
        '';

      if (isEuCountry(marketCountry, euCodes)) {
        setRequired(true);
        return;
      }

      const cached = readGeoCache();
      if (cached) {
        setRequired(isEuCountry(cached, euCodes));
        return;
      }

      const ipCountry = await fetchIpCountry();
      if (ipCountry) {
        writeGeoCache(ipCountry);
        setRequired(isEuCountry(ipCountry, euCodes));
        return;
      }

      // Geo lookup failed — keep Markets result (non-EU SSR default).
      setRequired(false);
    };

    document.addEventListener('change', async (event) => {
      const input = event.target.closest('[data-digital-waiver-input]');
      if (!input) return;

      const root = input.closest('[data-digital-waiver]');
      if (!root || root.hidden) return;

      const accepted = input.checked;

      // Keep checkout locked until cart attributes persist successfully.
      if (!accepted) {
        setAcceptedUI(false, { showHint: false, saving: true });
        try {
          await persistCartAttributes(false, root);
          setAcceptedUI(false, { showHint: true, saving: false });
        } catch (_) {
          setAcceptedUI(true, { showHint: true, saving: false });
        }
        return;
      }

      setAcceptedUI(true, { showHint: false, saving: true });
      try {
        const { stampedAt } = await persistCartAttributes(true, root);
        roots().forEach((other) => {
          other.querySelectorAll('[data-waiver-attr="eu_digital_waiver_at"]').forEach((field) => {
            field.value = stampedAt;
          });
        });
        setAcceptedUI(true, { showHint: false, saving: false });
      } catch (_) {
        setAcceptedUI(false, { showHint: true, saving: false });
      }
    });

    document.addEventListener(
      'click',
      (event) => {
        if (!waiverIsRequired()) return;

        const checkoutBtn = event.target.closest('[name="checkout"], [data-digital-waiver-checkout]');
        if (!checkoutBtn) return;

        const scope = checkoutBtn.closest('[data-digital-waiver-scope]');
        if (!scope || scope.dataset.waiverRequired !== 'true') return;
        if (scope.dataset.waiverAccepted === 'true') return;

        const root = scope.querySelector('[data-digital-waiver]');
        if (!root || root.dataset.gateCheckout !== 'true') return;

        event.preventDefault();
        event.stopPropagation();
        setAcceptedUI(false, { showHint: true, saving: false });
        root.querySelector('[data-digital-waiver-input]')?.focus();
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        if (!waiverIsRequired()) return;

        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const scope = form.closest('[data-digital-waiver-scope]');
        if (!scope || scope.dataset.waiverRequired !== 'true') return;

        const root = scope.querySelector('[data-digital-waiver]');
        if (!root) return;

        const submitter = event.submitter;
        const isCheckout =
          submitter?.getAttribute('name') === 'checkout' ||
          submitter?.hasAttribute('data-digital-waiver-checkout');

        const isAccelerated =
          root.dataset.gateAccelerated === 'true' &&
          (submitter?.closest('.shopify-payment-button') ||
            form.querySelector('shopify-accelerated-checkout') ||
            form.querySelector('shopify-accelerated-checkout-cart'));

        if (!isCheckout && !(isAccelerated && submitter?.name !== 'add')) return;
        if (scope.dataset.waiverAccepted === 'true') return;

        event.preventDefault();
        event.stopPropagation();
        setAcceptedUI(false, { showHint: true, saving: false });
        root.querySelector('[data-digital-waiver-input]')?.focus();
      },
      true
    );

    window.PFDigitalWaiver = {
      sync,
      setAcceptedUI,
      setRequired,
      resolveRequirement,
      ATTR_KEYS,
    };

    // SSR may already require via Markets; still resolve IP for non-EU Markets.
    const initiallyRequired = scopes().some((scope) => scope.dataset.waiverRequired === 'true');
    if (initiallyRequired) {
      sync();
    }
    resolveRequirement();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["genre-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const handleize = (value) =>
      String(value || '')
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const readUrlGenre = () => {
      try {
        return handleize(new URL(window.location.href).searchParams.get('genre'));
      } catch (e) {
        return '';
      }
    };

    const writeUrlGenre = (genre, clearUrl) => {
      try {
        const current = new URL(window.location.href);
        const url = new URL(clearUrl || window.location.href, window.location.origin);
        const sortBy = current.searchParams.get('sort_by');
        if (sortBy) url.searchParams.set('sort_by', sortBy);
        else url.searchParams.delete('sort_by');
        if (genre) url.searchParams.set('genre', genre);
        else url.searchParams.delete('genre');
        url.searchParams.delete('page');
        const next = `${url.pathname}${url.search}${url.hash}`;
        if (`${window.location.pathname}${window.location.search}${window.location.hash}` !== next) {
          window.history.replaceState({}, '', next);
        }
      } catch (e) {
        /* ignore */
      }
    };

    const initFilter = (root) => {
      const list = root.querySelector('[data-genre-filter-list]');
      const gridSelector = root.getAttribute('data-grid-selector') || '[data-genre-grid]';
      const countSelector = root.getAttribute('data-count-selector') || '[data-genre-count]';
      const emptySelector = root.getAttribute('data-empty-selector') || '[data-genre-empty]';
      const clearUrl = root.getAttribute('data-clear-url') || window.location.pathname;
      const seedGenre = handleize(root.getAttribute('data-active-genre') || '');
      const countOne = root.getAttribute('data-count-one') || '';
      const countOther = root.getAttribute('data-count-other') || '';
      const grid = document.querySelector(gridSelector);
      if (!list || !grid) return;

      const items = () => Array.from(grid.querySelectorAll('[data-genre-item]'));
      const emptyEl = document.querySelector(emptySelector);
      const countEl = document.querySelector(countSelector);
      const defaultCountText = countEl?.getAttribute('data-genre-count-default') || countEl?.textContent || '';
      const pagination = document.querySelector('[data-genre-pagination]');

      const formatCount = (count) => {
        const template = count === 1 ? countOne || countOther : countOther || countOne;
        if (!template) return String(count);
        return template.replace(/\{\{\s*count\s*\}\}/g, String(count));
      };

      const applyFilter = (genre, { syncUrl = true, keepFromSearch = false } = {}) => {
        const active = handleize(genre);
        let visible = 0;

        items().forEach((item) => {
          const handles = (item.getAttribute('data-genres') || '')
            .split(',')
            .map(handleize)
            .filter(Boolean);
          // Title / keyword search hits stay visible for search-term genre auto-match
          const fromSearch = keepFromSearch && item.hasAttribute('data-from-search');
          const match = !active || handles.includes(active) || fromSearch;
          item.hidden = !match;
          if (match) visible += 1;
        });

        list.querySelectorAll('[data-genre-value]').forEach((btn) => {
          const isActive = handleize(btn.getAttribute('data-genre-value')) === active;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (countEl) {
          countEl.textContent = active ? formatCount(visible) : defaultCountText;
        }

        if (emptyEl) {
          emptyEl.hidden = !(active && visible === 0);
        }

        grid.hidden = active && visible === 0;

        if (pagination) {
          pagination.hidden = Boolean(active);
        }

        if (syncUrl) writeUrlGenre(active, clearUrl);
      };
      list.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-genre-value]');
        if (!btn || !list.contains(btn)) return;
        applyFilter(btn.getAttribute('data-genre-value') || '', {
          syncUrl: true,
          keepFromSearch: false,
        });
      });

      // Also allow clicking genre tags on cards
      grid.addEventListener('click', (event) => {
        const tag = event.target.closest('[data-genre-tag]');
        if (!tag || !grid.contains(tag)) return;
        event.preventDefault();
        applyFilter(tag.getAttribute('data-genre-tag') || '', {
          syncUrl: true,
          keepFromSearch: false,
        });
      });

      // URL genre wins (exclusive). Search-term genre seed keeps title/keyword hits visible.
      const urlGenre = readUrlGenre();
      const initialGenre = urlGenre || seedGenre;
      applyFilter(initialGenre, {
        syncUrl: Boolean(urlGenre),
        keepFromSearch: Boolean(seedGenre) && !urlGenre,
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-genre-filter]').forEach(initFilter);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["listing-filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const handleize = (value) =>
      String(value || '')
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const parseList = (value) =>
      String(value || '')
        .split(',')
        .map(handleize)
        .filter(Boolean);

    const unique = (list) => [...new Set(list)];

    const normalizeTypes = (list) =>
      unique(list.map((t) => (t === 'bundle' ? 'bundles' : t)));

    const readUrlFilters = () => {
      try {
        const params = new URL(window.location.href).searchParams;
        return {
          genres: unique(parseList(params.get('genre'))),
          types: normalizeTypes(parseList(params.get('product_type'))),
        };
      } catch (e) {
        return { genres: [], types: [] };
      }
    };

    const writeUrlFilters = (genres, types, clearUrl) => {
      try {
        const current = new URL(window.location.href);
        const url = new URL(clearUrl || window.location.href, window.location.origin);
        const sortBy = current.searchParams.get('sort_by');
        const q = current.searchParams.get('q');
        const searchType = current.searchParams.get('type');

        if (q) url.searchParams.set('q', q);
        if (searchType === 'product' || searchType === 'article' || searchType === 'page') {
          url.searchParams.set('type', searchType);
        }
        if (sortBy) url.searchParams.set('sort_by', sortBy);
        else url.searchParams.delete('sort_by');

        if (genres.length) url.searchParams.set('genre', genres.join(','));
        else url.searchParams.delete('genre');

        if (types.length) url.searchParams.set('product_type', types.join(','));
        else url.searchParams.delete('product_type');

        url.searchParams.delete('page');
        url.searchParams.delete('filter');

        const next = `${url.pathname}${url.search}${url.hash}`;
        if (`${window.location.pathname}${window.location.search}${window.location.hash}` !== next) {
          window.history.replaceState({}, '', next);
        }
      } catch (e) {
        /* ignore */
      }
    };

    const initRoot = (root) => {
      const gridSelector = root.getAttribute('data-grid-selector') || '[data-genre-grid]';
      const countSelector = root.getAttribute('data-count-selector') || '[data-genre-count]';
      const emptySelector = root.getAttribute('data-empty-selector') || '[data-genre-empty]';
      const clearUrl = root.getAttribute('data-clear-url') || window.location.pathname;
      const countOne = root.getAttribute('data-count-one') || '';
      const countOther = root.getAttribute('data-count-other') || '';
      const keepFromSearchDefault = root.getAttribute('data-keep-from-search') === 'true';
      const seedGenres = parseList(root.getAttribute('data-active-genres') || '');
      const seedTypes = normalizeTypes(parseList(root.getAttribute('data-active-types') || ''));
      const grid = document.querySelector(gridSelector);
      if (!grid) return;

      const drawer = root.querySelector('[data-listing-filters-drawer]');
      const sheet = root.querySelector('[data-listing-filters-sheet]');
      const drawerBody = root.querySelector('[data-listing-filters-drawer-body]');
      const emptyEl = document.querySelector(emptySelector);
      const countEl = document.querySelector(countSelector);
      const defaultCountText = countEl?.getAttribute('data-genre-count-default') || countEl?.textContent || '';
      const pagination = document.querySelector('[data-genre-pagination]');
      const openButtons = document.querySelectorAll('[data-listing-filters-open]');
      const clearButtons = root.querySelectorAll('[data-listing-filters-clear]');
      const badgeEls = document.querySelectorAll('[data-listing-filters-badge]');
      const drawerHome = drawer?.parentNode || null;

      let keepFromSearch = false;
      let lastFocus = null;
      let lockedScrollY = 0;
      let closeTimer = 0;

      const inputs = () => {
        const list = Array.from(root.querySelectorAll('[data-listing-filter-input]'));
        if (drawer && !root.contains(drawer)) {
          list.push(...drawer.querySelectorAll('[data-listing-filter-input]'));
        }
        return list;
      };
      const items = () => Array.from(grid.querySelectorAll('[data-genre-item]'));

      const formatCount = (count) => {
        const template = count === 1 ? countOne || countOther : countOther || countOne;
        if (!template) return String(count);
        return template.replace(/\{\{\s*count\s*\}\}/g, String(count));
      };

      const getSelected = () => {
        const genres = [];
        const types = [];
        inputs().forEach((input) => {
          if (!input.checked) return;
          const value = handleize(input.value);
          if (!value) return;
          if (input.getAttribute('data-filter-group') === 'genre') genres.push(value);
          if (input.getAttribute('data-filter-group') === 'type') types.push(value);
        });
        return { genres: unique(genres), types: unique(types) };
      };

      const setSelected = (genres, types) => {
        const genreSet = new Set(genres);
        const typeSet = new Set(types);
        inputs().forEach((input) => {
          const value = handleize(input.value);
          if (input.getAttribute('data-filter-group') === 'genre') {
            input.checked = genreSet.has(value);
          } else if (input.getAttribute('data-filter-group') === 'type') {
            input.checked = typeSet.has(value);
          }
        });
      };

      const syncUiChrome = (genres, types) => {
        const activeCount = genres.length + types.length;
        clearButtons.forEach((btn) => {
          if (btn.closest('[data-listing-filters-drawer]')) {
            btn.disabled = activeCount === 0;
          } else {
            btn.hidden = activeCount === 0;
          }
        });
        badgeEls.forEach((badge) => {
          if (activeCount > 0) {
            badge.hidden = false;
            badge.textContent = String(activeCount);
          } else {
            badge.hidden = true;
            badge.textContent = '';
          }
        });
        openButtons.forEach((btn) => {
          btn.setAttribute('aria-expanded', drawer?.classList.contains('is-open') ? 'true' : 'false');
        });
      };

      const lockPageScroll = () => {
        lockedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.classList.add('listing-filters-drawer-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${lockedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.documentElement.style.overflow = 'hidden';
      };

      const unlockPageScroll = () => {
        document.body.classList.remove('listing-filters-drawer-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.documentElement.style.overflow = '';
        window.scrollTo(0, lockedScrollY);
      };

      const applyFilters = ({ syncUrl = true } = {}) => {
        const { genres, types } = getSelected();
        let visible = 0;
        const hasGenreFilter = genres.length > 0;
        const hasTypeFilter = types.length > 0;

        items().forEach((item) => {
          const itemGenres = parseList(item.getAttribute('data-genres') || '');
          const itemTypes = parseList(item.getAttribute('data-product-types') || '');
          const fromSearch = keepFromSearch && item.hasAttribute('data-from-search');

          const genreMatch =
            !hasGenreFilter || fromSearch || genres.some((g) => itemGenres.includes(g));
          const typeMatch =
            !hasTypeFilter || types.some((t) => itemTypes.includes(t));

          const match = genreMatch && typeMatch;
          item.hidden = !match;
          if (match) visible += 1;
        });

        const filtering = hasGenreFilter || hasTypeFilter;

        if (countEl) {
          countEl.textContent = filtering ? formatCount(visible) : defaultCountText;
        }

        if (emptyEl) {
          emptyEl.hidden = !(filtering && visible === 0);
        }

        grid.hidden = filtering && visible === 0;

        if (pagination) {
          pagination.hidden = filtering;
        }

        syncUiChrome(genres, types);
        if (syncUrl) writeUrlFilters(genres, types, clearUrl);
      };

      const openDrawer = () => {
        if (!drawer || !sheet) return;
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = 0;
        }
        lastFocus = document.activeElement;
        // Move to body so position:fixed is never clipped by transformed ancestors
        if (drawer.parentNode !== document.body) {
          document.body.appendChild(drawer);
        }
        drawer.hidden = false;
        if (drawerBody) drawerBody.scrollTop = 0;
        lockPageScroll();
        requestAnimationFrame(() => {
          drawer.classList.add('is-open');
        });
        const focusTarget =
          sheet.querySelector('[data-listing-filter-input]') ||
          sheet.querySelector('[data-listing-filters-close]');
        focusTarget?.focus({ preventScroll: true });
        openButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
      };

      const closeDrawer = () => {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        openButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        closeTimer = window.setTimeout(() => {
          drawer.hidden = true;
          unlockPageScroll();
          if (drawerHome && drawer.parentNode === document.body) {
            drawerHome.appendChild(drawer);
          }
          if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus({ preventScroll: true });
          }
          closeTimer = 0;
        }, 280);
      };

      root.addEventListener('change', (event) => {
        const input = event.target.closest('[data-listing-filter-input]');
        if (!input || !root.contains(input)) return;
        // Drawer may be moved to body; also accept inputs inside drawer
        const group = input.getAttribute('data-filter-group');
        const value = handleize(input.value);
        inputs().forEach((other) => {
          if (
            other !== input &&
            other.getAttribute('data-filter-group') === group &&
            handleize(other.value) === value
          ) {
            other.checked = input.checked;
          }
        });
        // Mirror drawer inputs when drawer is on body (outside root)
        if (drawer && !root.contains(drawer)) {
          drawer.querySelectorAll('[data-listing-filter-input]').forEach((other) => {
            if (
              other !== input &&
              other.getAttribute('data-filter-group') === group &&
              handleize(other.value) === value
            ) {
              other.checked = input.checked;
            }
          });
        }
        keepFromSearch = false;
        applyFilters({ syncUrl: true });
      });

      // Drawer lives on body while open — listen there too
      if (drawer) {
        drawer.addEventListener('change', (event) => {
          const input = event.target.closest('[data-listing-filter-input]');
          if (!input || !drawer.contains(input)) return;
          const group = input.getAttribute('data-filter-group');
          const value = handleize(input.value);
          inputs().forEach((other) => {
            if (
              other.getAttribute('data-filter-group') === group &&
              handleize(other.value) === value
            ) {
              other.checked = input.checked;
            }
          });
          keepFromSearch = false;
          applyFilters({ syncUrl: true });
        });
      }

      clearButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          keepFromSearch = false;
          setSelected([], []);
          applyFilters({ syncUrl: true });
        });
      });

      openButtons.forEach((btn) => {
        btn.addEventListener('click', () => openDrawer());
      });

      const bindClose = (el) => {
        el.querySelectorAll('[data-listing-filters-close]').forEach((btn) => {
          btn.addEventListener('click', () => closeDrawer());
        });
      };
      bindClose(root);
      if (drawer) bindClose(drawer);

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (!drawer || drawer.hidden || !drawer.classList.contains('is-open')) return;
        closeDrawer();
      });

      grid.addEventListener('click', (event) => {
        const tag = event.target.closest('[data-genre-tag]');
        if (!tag || !grid.contains(tag)) return;
        event.preventDefault();
        const handle = handleize(tag.getAttribute('data-genre-tag') || '');
        if (!handle) return;
        keepFromSearch = false;
        const { genres, types } = getSelected();
        const nextGenres = genres.includes(handle)
          ? genres.filter((g) => g !== handle)
          : [...genres, handle];
        setSelected(nextGenres, types);
        applyFilters({ syncUrl: true });
      });

      const urlFilters = readUrlFilters();
      const initialGenres = urlFilters.genres.length ? urlFilters.genres : seedGenres;
      const initialTypes = urlFilters.types.length ? urlFilters.types : seedTypes;
      keepFromSearch =
        keepFromSearchDefault && seedGenres.length > 0 && urlFilters.genres.length === 0;

      setSelected(initialGenres, initialTypes);
      applyFilters({
        syncUrl: urlFilters.genres.length > 0 || urlFilters.types.length > 0,
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-listing-filters]').forEach(initRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-demo-player"] && !Shopify.designMode) return;
  try {
    const initDemoPlayers = () => {
    document.querySelectorAll('[data-demo-player]').forEach((root) => {
      if (root.dataset.demoPlayerReady === 'true') return;

      const tracksJson = root.querySelector('[data-demo-player-tracks]');
      const audio = root.querySelector('[data-demo-player-audio]');
      const card = root.querySelector('[data-demo-player-card]');
      const sticky = root.querySelector('[data-demo-player-sticky]');
      if (!tracksJson || !audio || !card || !sticky) return;

      let tracks = [];
      try {
        tracks = JSON.parse(tracksJson.textContent);
      } catch {
        return;
      }
      if (!tracks.length) return;

      const state = {
        index: 0,
        peaks: new Map(),
        engaged: false,
        isStickyVisible: false,
        isScrubbing: false,
      };

      const els = {
        tracklist: root.querySelector('[data-demo-player-tracklist]'),
        trackButtons: [...root.querySelectorAll('[data-demo-player-track]')],
        playBtn: root.querySelector('[data-demo-player-play]'),
        prevBtn: root.querySelector('[data-demo-player-prev]'),
        nextBtn: root.querySelector('[data-demo-player-next]'),
        waveform: root.querySelector('[data-demo-player-waveform]'),
        timeCurrent: root.querySelector('[data-demo-player-time-current]'),
        timeTotal: root.querySelector('[data-demo-player-time-total]'),
        nowPlaying: root.querySelector('[data-demo-player-now-playing]'),
        stickyTitle: root.querySelector('[data-demo-player-sticky-title]'),
        stickyPlay: root.querySelector('[data-demo-player-sticky-play]'),
        stickyPrev: root.querySelector('[data-demo-player-sticky-prev]'),
        stickyNext: root.querySelector('[data-demo-player-sticky-next]'),
        stickyTime: root.querySelector('[data-demo-player-sticky-time]'),
        stickyDuration: root.querySelector('[data-demo-player-sticky-duration]'),
        scrubber: root.querySelector('[data-demo-player-scrubber]'),
        trackDurations: [...root.querySelectorAll('[data-demo-player-track-duration]')],
      };

      const playButtons = [els.playBtn, els.stickyPlay].filter(Boolean);

      /* Last-play wins: pause the Preview Select Sounds iframe when demos start. */
      const pausePreviewerIframes = () => {
        document.querySelectorAll('[data-audiopreviewer-iframe]').forEach((iframe) => {
          try {
            const src = iframe.getAttribute('src');
            if (!src || src === 'about:blank') return;
            const origin = new URL(src, window.location.href).origin;
            iframe.contentWindow?.postMessage({ type: 'AUDIOPREVIEWER_PAUSE' }, origin);
          } catch {
            /* ignore cross-origin / missing src */
          }
        });
      };

      const isMessageFromPreviewer = (event) => {
        return [...document.querySelectorAll('[data-audiopreviewer-iframe]')].some(
          (iframe) => iframe.contentWindow === event.source
        );
      };

      const formatTime = (seconds) => {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const minutes = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${minutes}:${String(secs).padStart(2, '0')}`;
      };

      const loadTrackDurations = () => {
        els.trackDurations.forEach((el) => {
          const index = Number(el.dataset.demoPlayerTrackDuration);
          const track = tracks[index];
          if (!track) return;

          const probe = new Audio();
          probe.preload = 'metadata';
          probe.src = track.url;
          probe.addEventListener('loadedmetadata', () => {
            el.textContent = formatTime(probe.duration);
          });
        });
      };

      const setPlayState = (playing) => {
        playButtons.forEach((button) => {
          button.classList.toggle('is-playing', playing);
          button.setAttribute(
            'aria-label',
            playing ? button.dataset.pauseLabel : button.dataset.playLabel
          );
        });
        els.trackButtons.forEach((button) => {
          const isCurrentTrack = Number(button.dataset.trackIndex) === state.index;
          button.classList.toggle('is-playing', playing && isCurrentTrack);
        });
      };

      const updateTrackUi = () => {
        const track = tracks[state.index];
        els.trackButtons.forEach((button) => {
          const isActive = Number(button.dataset.trackIndex) === state.index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (!isActive) button.classList.remove('is-playing');
        });
        if (els.stickyTitle && track) els.stickyTitle.textContent = track.title;
        if (els.nowPlaying && track) els.nowPlaying.textContent = track.title;
      };

      /*
        Browse nav only (↑/↓, prev/next, auto-advance): keep the active row in
        the tracklist scroller. Adjust scrollTop from rect deltas — never
        scrollIntoView, which would scroll the host page.
      */
      const scrollActiveTrackIntoView = () => {
        const scroller = els.tracklist;
        const el = els.trackButtons[state.index];
        if (!scroller || !el) return;
        if (scroller.scrollHeight <= scroller.clientHeight + 1) return;

        window.setTimeout(() => {
          const scrollerRect = scroller.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();
          const fullyVisible =
            elRect.top >= scrollerRect.top - 1 && elRect.bottom <= scrollerRect.bottom + 1;

          if (fullyVisible) return;

          scroller.scrollTo({
            top: scroller.scrollTop + (elRect.top - scrollerRect.top),
            behavior: 'smooth',
          });
        }, 40);
      };

      const updateTimes = () => {
        const current = formatTime(audio.currentTime);
        const total = formatTime(audio.duration);
        if (els.timeCurrent) els.timeCurrent.textContent = current;
        if (els.timeTotal) els.timeTotal.textContent = total;
        if (els.stickyTime) els.stickyTime.textContent = current;
        if (els.stickyDuration) els.stickyDuration.textContent = total;
        if (els.scrubber && audio.duration) {
          els.scrubber.value = String((audio.currentTime / audio.duration) * 100);
        }
        if (els.waveform) {
          els.waveform.setAttribute('aria-valuenow', String(Math.round((audio.currentTime / (audio.duration || 1)) * 100)));
        }
      };

      const drawWaveform = () => {
        const canvas = els.waveform;
        if (!canvas) return;

        const peaks = state.peaks.get(state.index);
        if (!peaks) return;

        const context = canvas.getContext('2d');
        if (!context) return;

        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        if (!width || !height) return;

        const ratio = window.devicePixelRatio || 1;
        canvas.width = Math.floor(width * ratio);
        canvas.height = Math.floor(height * ratio);
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        context.clearRect(0, 0, width, height);

        const barWidth = width / peaks.length;
        const progress = audio.duration ? audio.currentTime / audio.duration : 0;
        const accent = getComputedStyle(root).getPropertyValue('--color-accent').trim() || '#ff5a2a';
        const inactive = getComputedStyle(root).getPropertyValue('--color-foreground').trim() || '#ffffff';

        peaks.forEach((peak, index) => {
          const barHeight = Math.max(2, peak * (height - 8));
          const x = index * barWidth;
          const y = (height - barHeight) / 2;
          const barProgress = (index + 0.5) / peaks.length;
          const isPlayed = barProgress <= progress;
          context.globalAlpha = isPlayed ? 1 : 0.35;
          context.fillStyle = isPlayed ? accent : inactive;
          context.fillRect(x + 0.5, y, Math.max(1, barWidth - 1), barHeight);
        });
        context.globalAlpha = 1;
      };

      const decodePeaks = async (url) => {
        const response = await fetch(url);
        const buffer = await response.arrayBuffer();
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        const audioContext = new AudioContextClass();
        const audioBuffer = await audioContext.decodeAudioData(buffer);
        const channel = audioBuffer.getChannelData(0);
        const barCount = 96;
        const samplesPerBar = Math.floor(channel.length / barCount);
        const peaks = [];

        for (let i = 0; i < barCount; i += 1) {
          const start = i * samplesPerBar;
          const end = start + samplesPerBar;
          let max = 0;
          for (let j = start; j < end; j += 1) {
            max = Math.max(max, Math.abs(channel[j]));
          }
          peaks.push(max);
        }

        audioContext.close();
        return peaks;
      };

      const ensurePeaks = async (index) => {
        if (state.peaks.has(index)) return;
        try {
          const peaks = await decodePeaks(tracks[index].url);
          state.peaks.set(index, peaks);
        } catch {
          const fallback = Array.from({ length: 96 }, (_, i) => 0.15 + ((i % 7) * 0.08));
          state.peaks.set(index, fallback);
        }
      };

      const updateStickyVisibility = () => {
        if (!state.engaged || audio.paused) {
          sticky.hidden = true;
          return;
        }
        sticky.hidden = !state.isStickyVisible;
      };

      const loadTrack = async (index, autoplay = false) => {
        state.index = (index + tracks.length) % tracks.length;
        const track = tracks[state.index];
        audio.src = track.url;
        audio.load();
        updateTrackUi();
        await ensurePeaks(state.index);
        drawWaveform();
        updateTimes();
        if (autoplay) {
          try {
            await audio.play();
            setPlayState(true);
          } catch {
            setPlayState(false);
          }
        }
      };

      const togglePlay = async () => {
        state.engaged = true;
        if (audio.paused) {
          if (!audio.src) await loadTrack(state.index, false);
          try {
            await audio.play();
            setPlayState(true);
          } catch {
            setPlayState(false);
          }
        } else {
          audio.pause();
          setPlayState(false);
        }
        updateStickyVisibility();
      };

      const seekToRatio = (ratio) => {
        if (!audio.duration) return;
        const clamped = Math.min(1, Math.max(0, ratio));
        audio.currentTime = clamped * audio.duration;
        updateTimes();
        drawWaveform();
      };

      const bindPlayButtons = (buttons) => {
        buttons.forEach((button) => {
          if (!button) return;
          button.addEventListener('click', togglePlay);
        });
      };

      bindPlayButtons([els.playBtn, els.stickyPlay]);

      const playPrev = () => {
        state.engaged = true;
        const wasPlaying = !audio.paused;
        loadTrack(state.index - 1, wasPlaying);
        scrollActiveTrackIntoView();
        updateStickyVisibility();
      };

      const playNext = () => {
        state.engaged = true;
        const wasPlaying = !audio.paused;
        loadTrack(state.index + 1, wasPlaying);
        scrollActiveTrackIntoView();
        updateStickyVisibility();
      };

      els.prevBtn?.addEventListener('click', playPrev);
      els.stickyPrev?.addEventListener('click', playPrev);
      els.nextBtn?.addEventListener('click', playNext);
      els.stickyNext?.addEventListener('click', playNext);

      els.trackButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          state.engaged = true;
          const nextIndex = Number(button.dataset.trackIndex);
          if (nextIndex === state.index && audio.src) {
            if (!audio.paused) {
              audio.pause();
              setPlayState(false);
            } else {
              try {
                await audio.play();
                setPlayState(true);
              } catch {
                setPlayState(false);
              }
            }
          } else {
            loadTrack(nextIndex, true);
          }
          updateStickyVisibility();
        });
      });

      els.waveform?.addEventListener('click', (event) => {
        const rect = els.waveform.getBoundingClientRect();
        const ratio = (event.clientX - rect.left) / rect.width;
        state.engaged = true;
        seekToRatio(ratio);
        updateStickyVisibility();
      });

      els.waveform?.addEventListener('keydown', (event) => {
        if (!audio.duration) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          seekToRatio((audio.currentTime - 5) / audio.duration);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          seekToRatio((audio.currentTime + 5) / audio.duration);
        }
      });

      /*
        Desktop: Space play/pause, ↑/↓ prev/next, ←/→ seek ±5s — parity with
        audiopreviewer. Ownership: engaged + (focus inside this player/sticky,
        or playing with loose body focus). Iframe embed keeps its own document,
        so keys never compete across players; idle Space still scrolls the page.
      */
      const SEEK_SECONDS = 5;

      const isTypingTarget = (target) => {
        if (!(target instanceof HTMLElement)) return false;
        return (
          target.isContentEditable ||
          target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT'
        );
      };

      const ownsKeyboard = () => {
        if (!state.engaged) return false;
        const active = document.activeElement;
        if (active instanceof Node && (root.contains(active) || sticky.contains(active))) {
          return true;
        }
        if (audio.paused) return false;
        return !active || active === document.body || active === document.documentElement;
      };

      const onTransportKeyDown = (event) => {
        const isNav = event.key === 'ArrowUp' || event.key === 'ArrowDown';
        const isSeek = event.key === 'ArrowLeft' || event.key === 'ArrowRight';
        const isSpace = event.key === ' ' || event.key === 'Spacebar';
        if (!isNav && !isSeek && !isSpace) return;
        if (event.altKey || event.ctrlKey || event.metaKey || ((isNav || isSeek) && event.shiftKey)) {
          return;
        }
        if (!window.matchMedia('(min-width: 640px)').matches) return;
        if (isTypingTarget(event.target)) return;
        if (!ownsKeyboard()) return;
        if (isSeek && !audio.duration) return;

        event.preventDefault();
        event.stopPropagation();

        if (isSeek) {
          const delta = event.key === 'ArrowRight' ? SEEK_SECONDS : -SEEK_SECONDS;
          seekToRatio((audio.currentTime + delta) / audio.duration);
          return;
        }

        if (isSpace) {
          togglePlay();
          return;
        }
        if (event.key === 'ArrowDown') playNext();
        else playPrev();
      };

      window.addEventListener('keydown', onTransportKeyDown, true);

      els.scrubber?.addEventListener('input', () => {
        state.isScrubbing = true;
        if (!audio.duration) return;
        seekToRatio(Number(els.scrubber.value) / 100);
      });

      els.scrubber?.addEventListener('change', () => {
        state.isScrubbing = false;
      });

      audio.addEventListener('timeupdate', () => {
        if (!state.isScrubbing) updateTimes();
        drawWaveform();
      });

      audio.addEventListener('loadedmetadata', updateTimes);
      audio.addEventListener('ended', () => {
        setPlayState(false);
        updateStickyVisibility();
        if (state.index < tracks.length - 1) {
          loadTrack(state.index + 1, true);
          scrollActiveTrackIntoView();
        }
      });

      audio.addEventListener('play', () => {
        setPlayState(true);
        updateStickyVisibility();
        pausePreviewerIframes();
      });
      audio.addEventListener('pause', () => {
        setPlayState(false);
        updateStickyVisibility();
      });

      const onPreviewerPlaying = (event) => {
        if (event.data?.type !== 'AUDIOPREVIEWER_PLAYING') return;
        if (!isMessageFromPreviewer(event)) return;
        if (!audio.paused) {
          audio.pause();
        }
      };
      window.addEventListener('message', onPreviewerPlaying);

      const observer = new IntersectionObserver(
        ([entry]) => {
          state.isStickyVisible = !entry.isIntersecting;
          updateStickyVisibility();
        },
        { threshold: 0, rootMargin: '0px 0px -1px 0px' }
      );
      observer.observe(card);

      /* Keep fixed sticky on the viewport even if ancestors use transform/animation. */
      const sectionEl = root.closest('.shopify-section');
      const stickyHost = sectionEl?.id || `demo-player-${Date.now()}`;
      document
        .querySelectorAll(`[data-demo-player-sticky-host="${stickyHost}"]`)
        .forEach((el) => {
          if (el !== sticky) el.remove();
        });
      sticky.dataset.demoPlayerStickyHost = stickyHost;
      document.body.appendChild(sticky);

      const cleanupSticky = () => {
        observer.disconnect();
        window.removeEventListener('message', onPreviewerPlaying);
        window.removeEventListener('keydown', onTransportKeyDown, true);
        sticky.remove();
      };

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === sectionEl) cleanupSticky();
      });

      window.addEventListener('resize', drawWaveform);

      root.dataset.demoPlayerReady = 'true';
      setPlayState(false);
      loadTrackDurations();
      loadTrack(0, false);
    });
  };

  initDemoPlayers();
  document.addEventListener('shopify:section:load', initDemoPlayers);
  } catch(e) { console.error(e); }
})();

})();
